import React from 'react';
import PropTypes from 'prop-types';
import {isCurrentUser} from '../../../helpers/user-helpers';
import checkIcon from '../../../assets/images/check.svg';

/* Styles */
import './user-checkmark.scss';

class UserCheckmark extends React.PureComponent {
  render() {
    return (
      <div className="glu-user-checkmark">
        {this.props.label}
        {isCurrentUser(this.props.ownerId) ? (
          <>
            <span>me&nbsp;</span>
            <img src={checkIcon} alt="check" />
          </>
        ) : (
          this.props.userLabel
        )}
      </div>
    );
  }
}

UserCheckmark.propTypes = {
  label: PropTypes.string,
  ownerId: PropTypes.string,
  userLabel: PropTypes.string,
};

UserCheckmark.defaultProps = {
  label: '',
  ownerId: '',
  userLabel: '',
};

export default UserCheckmark;
